<template>
  <v-card style="border-radius: 10px">
    <v-card-title>Your Plan</v-card-title>
    <v-card-text>
      You are currently on the
      <v-chip class="mr-1">{{ user.plan }}</v-chip
      >plan.
      <strong>Your plan</strong>
      ends at {{ $moment(user.planEndingAt).format("YYYY-MM-DD HH:mm") }}.
      <div>
        Check
        <router-link to="/buy">buy page</router-link>
        {{ " " }}to upgrade your account.
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapState } from "vuex";
export default {
  components: {},
  computed: {
    ...mapState(["user"]),
  },
};
</script>